import { StringsType } from "./StringsKeys";

const en: StringsType = {
  open: "Open",
  import: "Import",
  french: "French",
  english: "English",
  hello: "Hello",
  dashboard: "Dashboard",
  createAccount: "Create Account",
  createClient: "Create Client",
  clientName: "Client Name",
  clientEmail: "Client Email",
  clientPhone: "Client Phone",
  customerSince: "Customer Since",
  clientStatus: "Client Status",
  riskLevel: "Risk Level",
  risk: "Risk",
  profileRating: "Profile Rating",
  consolidatedBalance: "Consolidated Balance",
  folderStatus: "Folder Status",
  completionPercentage: "Completion %",
  lastUpdated: "Last Updated",
  viewDetails: "View Details",
  details: "Details",
  compare: "Compare",
  edit: "Edit",
  delete: "Delete",
  assignAdvisor: "Assign Advisor",
  updateRiskLevel: "Update Risk Level",
  searchClients: "Search clients...",
  filterByAgency: "Filter by Agency",
  filterByStatus: "Filter by Status",
  filterByRiskLevel: "Filter by Risk Level",
  filterByAdvisor: "Filter by Advisor",
  allAgencies: "All Agencies",
  allStatuses: "All Statuses",
  allRiskLevels: "All Risk Levels",
  allAdvisors: "All Advisors",
  active: "Active",
  inactive: "Inactive",
  dormant: "Dormant",
  moderate: "Moderate",
  high: "High",
  veryHigh: "Very High",
  low: "Low",
  assigned: "Assigned",
  unassigned: "Unassigned",
  totalClients: "Total Clients",
  activeClients: "Active Clients",
  highRiskClients: "High Risk Clients",
  unassignedClients: "Unassigned Clients",
  totalPortfolioValue: "Total Portfolio Value",
  averageProfileRating: "Average Profile Rating",
  loadingClients: "Loading clients...",
  noClientsFound: "No clients found",
  clientDetails: "Client Details",
  accountInformation: "Account Information",
  clientInformation: "Client Information",
  applicantContactDetails: "Applicant Contact Details",
  incomeInformation: "Income Information",
  accountType: "Account Type",
  fullName: "Full Name",
  businessKey: "Business Key",
  dateOfBirth: "Date of Birth",
  phone: "Phone",
  incomeSource: "Income Source",
  requiredDocuments: "Required Documents",
  documentsPending: "Documents Pending",
  uploadAllDocuments: "Upload All Documents",
  documentRequired: "Document Required",
  documentOptional: "Document Optional",
  upload: "Upload",
  documentsProcessed: "Documents Processed",
  progress: "Progress",
  loadingDocuments: "Loading documents...",
  documentLoadingError: "Error loading required documents",
  retryLoadingDocuments: "Retry",
  addNewClient: "Add New Client",
  exportData: "Export Data",
  refreshData: "Refresh Data",
  percent: "%",
  documents: "Documents",

  // Form Steps
  personalInformation: "Personal Information",
  contactAddressDetails: "Contact & Address Details",
  professionalFamilyInformation: "Professional & Family Information",
  professionalInformation: "Professional Information",
  familyInformation: "Family Information",

  summary: "Summary",

  // Personal Information Fields
  name: "Name",
  lastName: "Last Name",
  firstName: "First Name(s)",
  motherFullName: "Mother's Full Name",
  nationality: "Nationality",
  spokenLanguage: "Spoken Language",
  gender: "Gender",
  male: "Male",
  female: "Female",
  documentType: "Document Type",

  // Contact Details Fields
  mobilePhone: "Mobile Phone",
  homePhone: "Home Phone",
  countryOfResidence: "Country of Residence",
  cityMunicipality: "City/Municipality",
  address: "Address",
  postalAddressBP: "Postal address (P.O. Box)",
  geographicalLandmark: "Geographical Landmark",
  postalBox: "Postal Box",
  postalCode: "Postal Code",

  // Professional Information Fields
  isOwner: "Are you an owner?",
  monthlyIncome: "Monthly Income",
  hasOtherIncome: "Other Income?",
  otherIncomeAmount: "Other Income Amount",
  professionalCategory: "Professional Category",
  profession: "Profession",
  employer: "Employer",
  officePhone: "Office Phone",
  educationLevel: "Level of Education",
  maritalStatus: "Marital Status",
  numberOfChildren: "Number of Children",
  partnerFirstName: "Partner First Name",
  partnerLastName: "Partner Last Name",
  fatherLastName: "Father Last Name",
  fatherFirstName: "Father First Name",
  motherMaidenName: "Mother Last Name",
  motherFirstName: "Mother First Name",
  countryOfBirth: "Country of Birth",
  dependents: "Dependents",

  // Form Validation Messages
  fieldRequired: "This field is required",
  fieldLimited: "This field is limited to 50 characters",
  validName: "This field must at least contain 3 characters",
  phoneNumberInvalid: "Invalid phone number",
  invalidEmailFormat: "Invalid email format",
  mustBeGreaterThanZero: "Must be greater than 0",
  otherIncomeRequired:
    "Other income amount is required when other income is selected",

  // Form Status Messages
  formCompleteReady: "Form Complete & Ready to Submit",
  formIncompleteReview: "Form Incomplete - Please Review",
  formCompleteMessage:
    "All required fields have been completed. You can now submit the form.",
  formIncompleteMessage:
    "Some required fields are missing or incomplete. Please go back and complete all required fields before submitting.",

  // Navigation
  previous: "Previous",
  paginationPageSize: "per page",
  paginationPageInfo: "Page {current} / {total}",
  next: "Next",
  submit: "Submit",
  submitting: "Submitting...",
  back: "Back",

  // Form Steps Description
  personalInfoDescription: "Name, First name(s), gender, nationality...",
  contactInfoDescription: "Address, Phone, Email",
  professionalInfoDescription: "Income, assets, marital status",
  summaryDescription: "Review all information before submission",

  // Currency
  currency: "F CFA",

  // Placeholders
  placeholderLastName: "Ex: KOUASSI",
  placeholderFirstName: "Ex: Bernard",
  placeholderMotherName: "Ex: Bernardette KOUASSI",
  placeholderEmail: "Ex: mail@gmail.com",
  placeholderAddress: "Ex: Côte d'Ivoire, Abidjan, Cocody, Cité Verdoyante",
  placeholderLandmark: "Ex: Riviera 2, Anono, Near to, In front of...",
  placeholderProfession: "Ex: Tester",
  placeholderEmployer: "Ex: BOX AFRICA",

  // Cities
  abidjan: "Abidjan",
  yamoussoukro: "Yamoussoukro",
  bouake: "Bouaké",
  sanPedro: "San-Pédro",
  korhogo: "Korhogo",
  man: "Man",
  gagnoa: "Gagnoa",
  daloa: "Daloa",

  // Other
  other: "Other",
  notProvided: "Not provided",
  yes: "Yes",
  no: "No",
  administration: "Administration",
  rolesAndPermissions: "Roles & Permissions",
  users: "Users",
  attestations: "Attestations",
  offboarding: "Offboarding",
  jitAccess: "JIT Access",
  settings: "Settings",
  sodRules: "SoD Rules",
  adMapping: "AD Mappings",
  runtimeDecisions: "Runtime Decisions",
  enterprise: "Enterprise",
  expired: "Expired",
  newRole: "New Role",
  role: "Role",
  newRequest: "New Request",
  publishRole: "Publish Role",
  publishRoleAttestation:
    "I attest that this role complies with security and compliance policies",
  publishingRole: "Publishing role...",
  rolePublishedSuccess: "Role published successfully.",
  rolePublishedError: "Failed to publish role.",
  confirmPublishRoleTitle: "Confirm role publication",
  confirmPublishRoleDescription:
    "This action will publish this role permanently and make it available in production.",
  simulateUser: "Simulate User",
  mapAD: "Map AD",
  save: "Save",
  search: "Search",
  selectValue: "Select value...",
  searchValue: "Search value...",
  noValueFound: "No value found.",
  prospectsSearch: "Name, email, phone, ...",
  prospectsSearchSection: "Find a prospect",
  prospectsSearchFilters: "Refine pipeline",
  prospectsShowFilters: "Show search",
  prospectsHideFilters: "Hide search",
  statusProspect: "Prospect",
  statusPendingScreening: "Under compliance review (L1/EDD)",
  statusRefused: "Refused",
  statusFilterHelp: "What each status means",
  statusProspectHint:
    "Case still being put together, not yet registered as a customer. Shown together with the two other statuses when no filter is selected.",
  statusPendingScreeningHint:
    "Prospect already screened and registered in the referential but without a bank account, awaiting a compliance review decision (L1 or four-eyes EDD). The account is created once the review is approved.",
  statusRefusedHint:
    "Unfavourable review: the prospect stays registered and no account is created. Compliance can reopen the case, which sends it back to pending screening.",
  typeFilterHelp: "What each segment covers",
  physicalPersonHint:
    "Individual. This is the segment of the vast majority of cases, shown as \"PP\" in the list.",
  legalPersonHint:
    "Company or organisation, shown as \"PM\". Its case also carries a legal identity (legal form, RCCM) and its related persons.",
  channelFilterHelp: "How the relationship was opened",
  channelDigitalHint:
    "Opened remotely through the self-onboarding journey, without a branch visit or biometric verification. Scoring takes this into account.",
  channelAgencyHint:
    "Created in a branch by an advisor, with biometric verification of the customer.",
  channelCbsImportHint:
    "Customer already known to the core banking system, brought into the referential by synchronisation rather than created here.",
  channelWhatsappHint:
    "Opened remotely through WhatsApp Banking, without a branch visit or biometric verification. Same risk level as the Digital channel.",
  periodCreated: "Creation period",
  periodFilterHelp: "How the period is applied",
  periodFilterHint:
    "Filters on the case creation date. Both bounds are inclusive: from the 1st to the 1st does return the cases created that day. The list is only filtered once both dates are set.",
  channelDigital: "Digital",
  channelAgency: "Branch",
  channelCbsImport: "Imported from core banking",
  channelWhatsapp: "WhatsApp",
  prospectsSearchFiltersHint:
    "Filter prospects by type, status, and creation channel.",
  reset: "Reset",
  results: "Results",
  status: "Status",
  criticality: "Criticality",
  frequency: "Frequency",
  sod: "SoD",
  help: "Help",
  views: "Views",
  generalInformation: "General Information",
  prefilledFromCreationStep:
    "Already provided when the prospect was created. Click Edit to correct it.",
  matrixViewDescription: "Matrix view of roles and permissions",
  usersDescription: "Manage the users of the platform",
  usersSearchHint: "Name, login or email",
  roleAndOwner: "Role & Owner",
  archived: "Archived",
  draft: "Draft",
  published: "Published",
  none: "None",
  twoSod: "2 SoD →",
  consult: "Consult",
  modify: "Modify",
  approve: "Approve",
  export: "Export",
  compliance: "Compliance",
  credit: "Credit",
  gdpr: "GDPR",
  linesPerPage: "Lines per page",
  pageInfo: "Page {page} of {total}",
  notifications: "Notifications",
  noNotifications: "No notifications",
  noNotificationsHint:
    "Alerts about your cases, compliance, and administration will appear here.",
  notificationsUnread: "{{count}} unread",
  notificationsTabAll: "All",
  notificationsTabUnread: "Unread",
  notificationsEmptyUnread: "No unread notifications",
  notificationsToday: "Today",
  notificationsYesterday: "Yesterday",
  notificationsEarlier: "Earlier",
  markAllAsRead: "Mark all read",

  // Form Steps Title
  formSteps: "Form Steps",
  fillInInformation: "Fill in the information",

  // Error Messages
  pleaseFixErrors: "Please fix the following errors:",
  failedToSubmit: "Failed to submit form. Please try again.",
  formSubmittedSuccessfully: "Form submitted successfully!",
  contactInfoUpdated: "Contact information has been updated successfully.",

  // Step Status
  current: "current",
  completed: "completed",
  pending: "pending",
  error: "error",

  failedGettingUserRole: "Failed getting user role",
  backToHome: "Back to home",
  pageNotFound: "Page not found",
  WeCouldNotFindThePageYouAreLookingFor:
    "We couldn't find the page you are looking for.",
  internalServerError: "Internal server error",
  oopsSomethingWentWrong: "Oops, something went wrong",
  youAreNotAuthorized: "You are not authorized to access this page",
  youDonTHavePermissionToAccessThisPage:
    "You don't have permission to access this page",
  permissionDeniedPageDescription:
    "Your account does not include the required permissions. Contact your administrator if you need access.",
  welcomeTo: "Welcome to",
  pleaseSignIn: "Please sign-in to your account and start the adventure",
  password: "Password",
  rememberMe: "Remember me",
  loginHeroTitle: "Collaborator space",
  loginHeroSubtitle:
    "Access your compliance, KYC, and client file tools securely.",
  loginSecurityNote: "Secure and audited platform",
  loginFormSecurityNote: "Secure and encrypted connection",
  loginHelperText: "Enter your professional credentials to continue.",
  loginEmailPlaceholder: "e.g. agnese@bni.ci",
  credentials: "Credentials",
  badCredentials: "Authentication failed.",
  emailOrPasswordInvalid: "Email or Password is invalid",
  forgotPassword: "Forgot password",
  login: "Login",
  firstLoginResetTitle: "First sign-in",
  firstLoginResetSubtitle:
    "For security, you must set a new password before continuing.",
  currentPassword: "Current password",
  newPasswordChoice: "New password",
  confirmNewPassword: "Confirm new password",
  passwordsDoNotMatch: "Passwords do not match",
  passwordResetSuccess: "Password reset successfully.",
  passwordResetSuccessReconnectHint:
    "You can now sign in with your new password.",
  changePassword: "Save new password",
  passwordStrengthWeak: "Weak",
  passwordStrengthFair: "Fair",
  passwordStrengthGood: "Good",
  passwordStrengthStrong: "Strong",
  passwordStrengthHint: "Password strength",
  passwordRequirementMinLength: "At least 8 characters",
  passwordRequirementUppercase: "At least one uppercase letter",
  passwordRequirementLowercase: "At least one lowercase letter",
  passwordRequirementDigit: "At least one number",
  passwordRequirementSpecial: "At least one special character",
  passwordConfirmMatches: "Passwords match",
  passwordMustDifferFromCurrent:
    "New password must be different from your current password",
  inputLogin: "Identifier",
  newOnOurPlatform: "New on our platform",
  createAnAccount: "Create an account",
  or: "or",
  errorOccurred: "An error occurred",
  unexpectedOrNetworkError: "Unexpected or network error",
  unauthorizedAction: "Unauthorized action",
  subscriptionRequired: "Subscription required",
  resourceNotFound: "Resource not found",
  invalidInfos: "Invalid infos",
  conflictEncountered: "Conflict encountered",
  unavailableServer: "Unavailable server",
  logoutFailed: "Logout failed",
  logout: "Logout",
  sessionExpired: "Session expired",
  sessionExpiredMessage:
    "Your session has expired. Please log in again to continue.",
  externalResourceUnavailable:
    "External resource unavailable, please try again or try again later.",
  unexpectedError: "Unexpected error, please try again or try again later.",
  requiredField: "This field is required",
  invalidEmail: "Invalid email",
  invalidPassword: "Invalid password",
  email: "Email",
  failed: "Failed",
  userAvatar: "User avatar",
  operationFailed: "Operation failed",
  clientDataNotAvailable: "Client data not available.",
  FailedToLogoutUser: "Failed to logout user",
  tryAgain: "Try again",
  activities: "Activities",
  customers: "Customers",
  prospects: "Prospects",
  pipeline: "Pipeline",
  possibleMatch: "Possible match",
  duplicates: "Duplicates",
  individuals: "Individuals",
  professionals: "Professionals",
  products: "Products",
  inquirie_create_client: "Create client",
  inquiries: "Inquiries",
  inquirie: "Inquirie",
  folders: "Folders",
  marketing: "Marketing",
  atm: "Agencies & ATMs",
  period: "Period",
  day: "Day",
  week: "Week",
  month: "Month",
  trimester: "Trimester",
  semester: "Semester",
  year: "Year",
  compareToPreviousDay: "compared to the previous day",
  compareToPreviousWeek: "compared to last week",
  compareToPreviousMonth: "compared to last month",
  compareToPreviousTrimester: "compared to last quarter",
  compareToPreviousSemester: "compared to last semester",
  compareToPreviousYear: "compared to last year",
  client: "Client",
  client360: "Clients 360",
  client360SearchFilters: "Refine client search",
  client360SearchFiltersHint:
    "Combine criteria to narrow down the client list.",
  client360SearchSection: "Find a client",
  client360ShowFilters: "Show search",
  client360HideFilters: "Hide search",
  agency: "Agency",
  advisorName: "Advisor",
  since: "Since",
  profile: "Profile",
  totalBalance: "Total Balance",
  actions: "Actions",
  columns: "Columns",
  noResults: "No results.",
  selectedRows: "selected row(s)",
  advancedFilters: "Advanced Filters",
  kpi: "KPI",
  clear: "Clear",
  call: "Call",
  activity: "Activity",
  accountsProducts: "Account & Products",
  transactions: "Transactions",
  analyse: "Analyse risk",
  informations: "Informations",
  notesInteractions: "Notes & Interactions",
  networkError: "Network error",
  customersPerPage: "Customers per page",
  loading: "Loading",
  signature: "Signature",
  clientSince: "Customer since",
  placeOfBirth: "Place of birth",
  documentNumber: "Document number",
  dateOfIssue: "Date of issue",
  countryOfIssue: "Country of issue",
  placeOfDelivery: "Place of issue",
  documentReference: "Doc. reference",
  identityDocumentType: "Type of identity document",
  identityDocumentNumber: "Identity document number",
  nationalIdNumber: "National Identity Number (NIN)",
  expiryDate: "Expiry dade",
  validatedPart: "Validated part",
  completionLevel: "Completion level",

  // RBAC Matrix - Additional keys
  matrixRBAC: "RBAC Matrix",
  rbacMatrixSearchSection: "Search roles",
  rbacMatrixSearchHint: "Role name or label",
  rbacMatrixFilters: "Refine matrix",
  rbacMatrixFiltersHint:
    "Filter by status, criticality, review cadence, and SoD compliance.",
  rolesAndAttributions: "Roles & Attributions",
  medium: "Medium",
  dependencies: "Dependencies",
  nbPermissions: "Nb permissions",
  rulesManagement: "Rules",
  newRule: "New Rule",
  ruleName: "Rule name",
  ruleDescription: "Description",
  noRulesFound: "No rules found",
  invalidPhoneFormat: "Invalid phone format",

  // User
  user: "User",
  state: "State",
  presence: "Presence",
  backup: "Backup",
  permissions: "Permissions",

  // Documents
  category: "Category",
  date: "Date",
  send: "Send",
  download: "Download",
  documentDownloaded: "Document downloaded",
  documentDownloadError: "An error occurred while downloading the document",
  documentPreviewTitle: "Document preview",
  documentPreviewError: "Unable to load document preview",
  documentPreviewNotSupported: "Preview not available for this file type",
  screeningReportDownloaded: "Screening report downloaded",
  screeningReportDownloadError:
    "An error occurred while downloading the screening report",
  documentPerPage: "Documents per page",
  demandes: "Requests",
  nouvelleDemande: "New Request",
  // Demandes - Selection manuelle UI
  filters: "Filters",
  channel: "Channel",
  country: "Country",
  segment: "Segment",
  availableRequests: "Available requests",
  continue: "Continue",
  requiredFields: "Required fields",
  missingFields: "Missing fields",
  // Request items
  request_create_account: "Open a bank account",
  request_create_account_desc: "Start a bank account opening.",
  request_onboarding_a2: "Start Onboarding (A2)",
  request_onboarding_a2_desc:
    "Open an A2 onboarding case for a client/prospect.",
  request_regen_otp: "Regenerate access (OTP)",
  request_regen_otp_desc:
    "Send OTP instructions to reset password / reconnect.",
  request_secure_upload_reminder: "Secure upload reminder",
  request_secure_upload_reminder_desc:
    "Send a reminder with a secure link for document upload.",
  request_id_replacement: "Identity document replacement",
  request_id_replacement_desc:
    "Replace an expired or invalid identity document.",
  request_address_change: "Address change",
  request_address_change_desc: "Update address and supporting documents.",
  request_four_eyes: "4‑eyes document control",
  request_four_eyes_desc: "Trigger a 4‑eyes control on a document file.",
  request_rekcy: "Trigger Re‑KYC",
  request_rekcy_desc: "Open a Re‑KYC request according to the policy.",
  request_export_kpi: "Export compliance KPIs",
  request_export_kpi_desc:
    "Export KPIs (completeness, expired, OCR errors, reuse).",
  request_contact_update: "Contact details update",
  request_contact_update_desc: "Update client's contact information.",
  request_account_closure: "Account closure",
  request_account_closure_desc: "Close an active bank account.",
  request_add_proxy: "Add a power of attorney (proxy)",
  request_add_proxy_desc: "Create/add a proxy for a client (scope and limits).",
  request_pep_declaration: "PEP declaration",
  request_pep_declaration_desc:
    "Declare or update PEP status (client or relative).",
  request_civil_status_change: "Civil status change",
  request_civil_status_change_desc:
    "Declare a civil status change with supporting documents.",
  request_add_legal_representative: "Add legal representative",
  request_add_legal_representative_desc:
    "Add or designate a legal representative with documents.",
  request_income_employer_update: "Update income and employer",
  request_income_employer_update_desc:
    "Update monthly income, employer and activity sector.",
  request_family_situation_change: "Family situation change",
  request_family_situation_change_desc:
    "Update marital regime, spouse and number of children.",
  request_create_prospect: "Create a prospect",
  request_create_prospect_desc:
    "Enter a prospect and trigger the associated flow.",

  // Prospects
  type: "Type",
  contact: "Contact",
  accessStatus: "Access status",
  canal: "Canal",
  screening: "Screening",
  additionalDocuments: "Additional documents & exhibits",
  lastUpdate: "Last Update",
  createdAt: "Created at",

  birthDate: "Birth date",
  notes: "Notes",
  motif: "Reason",
  address1: "Address 1",
  address2: "Address 2",
  city: "City",
  deliveredDate: "Delivered date",
  IdDocType: "Type of document",
  IdDocNumber: "Document number",
  birthPlace: "Birth place",

  // Onboarding
  identification: "Identification",
  update: "Edit",
  editable: "Editable",
  readOnly: "Read only",

  // client
  clients: "Clients",
  selectClient: "Select a client",
  selectClientDescription: "Search for a client to open its 360° view.",
  clientSearch: "Name, Party ID, NCI, phone, email",
  sensitiveClientsFilter: "Sensitivity",
  sensitiveFilterAll: "All",
  sensitiveFilterWithout: "Non-sensitive",
  sensitiveFilterWith: "Sensitive",
  kyc: "KYC",
  partyid: "Party ID",
  account: "Accounts",

  synthese: "Synthesis",
  risqueReKyc: "Risk & Re-KYC",
  scoringProfilTitle: "Risk Profile",
  scoringScore: "Score",
  scoringDeclencheurs: "Triggers",
  scoringVoirDetails: "View details",
  scoringPolitiqueRisque: "Risk Policy",
  scoringNotCalculated: "Risk profile not yet calculated",
  scoringClasseDeRisque: "Risk class",
  scoringNonCalcule: "Not calculated",
  scoringTrackA: "Identity Reference",
  scoringTrackB: "External check",
  scoringCombined: "Combined score",
  scoringDecision: "Decision",
  scoringCompleteness: "Completeness",
  scoringScoredAt: "Scored at",
  scoringScoredBy: "Scored by",
  scoringTrigger: "Trigger",
  scoringFactorsTitle: "Factors",
  scoringLoadError: "Failed to load the risk profile.",
  scoringClassification: "Classification",
  scoringRawScore: "Raw score",
  scoringWeight: "Weight",
  scoringHardOverrides: "Overrides",
  scoringEntity: "Entity",
  scoringEntityLabel: "Label",
  scoringLevel: "Level",
  scoringPoints: "Points",
  accounts: "Accounts",
  accountSingular: "Account",
  consents: "Consents",
  timeline: "Timeline",
  fiche: "Client File",

  // Create Prospect Page
  createProspectPhysicalPersonTitle:
    "Create a prospect — Individual (PP) (BCEAO)",
  requiredInformation: "Required information",
  optionalInformation: "Optional information",
  physicalPerson: "Individual",
  sex: "Gender",
  masculine: "Male",
  feminine: "Female",
  selectOption: "Select",
  cni: "National ID",
  passport: "PASSPORT",
  drivingLicense: "DRIVING LICENSE",
  notesOptional: "Notes (optional)",
  dateFormat: "dd/mm/yyyy",
  errorCreatingProspect: "Error creating prospect",
  prospectCreatedSuccessfully: "Prospect created successfully!",
  prospectCreatedRedirectMessage:
    "Your prospect has been created successfully. You will be redirected...",
  requiredFieldsDisclaimer:
    "* required fields — at least one contact (phone or email).",
  cancel: "Cancel",
  create: "Create",
  creating: "Creating...",
  idType: "ID Type",
  idNumber: "ID Number",
  issueDate: "Issue Date",
  addressLine1: "Address (line 1)",
  addressLine2: "Address (line 2)",

  // New prospect form translations (English)
  civilite: "Title",
  genre: "Gender",
  masculineShort: "M",
  feminineShort: "F",
  mr: "Mr.",
  mrs: "Mrs.",
  miss: "Miss",
  mobile: "Mobile phone",
  sendOTP: "Send OTP",
  OTPSent: "OTP sent",
  verifyOTP: "Verify",
  otpCode: "Verification code",
  productOfInterest: "Product of interest",
  productsOfInterest: "Products of interest",
  intentComment: "Reason / Comment",
  intentCommentPlaceholder:
    "Specify the reason or add a comment… (280 characters max.)",
  createProspectAccountObject: "Account object",
  wantsContactForProducts: "Wants to be contacted for savings/card/credit",
  validateAndContinue: "Validate & continue",
  startOnboarding: "Start onboarding",
  coordinatesAndIntent: "Contact details & Intent",
  notesAndMentions: "Notes & @mentions",
  requestContext: "Request context",
  what: "What",
  produit: "Product",
  notDefined: "Not defined",
  characterLimit: "280 characters",
  chooseOption: "Choose",
  carte: "Card",
  epargne: "Savings",
  compteAVueXOF: "Current account (XOF)",
  suivant: "Next",

  rm: "RM",
  relationshipManager: "Relationship manager",
  prospectCreated: "Prospect created",
  prospectCreatedModalDescription:
    "Do you want to collect documents and consents?",
  prospectCreatedModalDescriptionPm:
    "Find it in the prospect list to continue processing it.",
  clientCreated: "Client created successfully",
  clientCreatedModalDescription:
    "Do you want to continue on the client profile?",
  nextStep: "Next steps",
  verifyRequiredDocuments: "Verify required documents.",
  confirmConsents: "Confirm KYC and marketing consents.",
  goToProspectList: "Back to the list of prospects",
  continueOnboarding: "Continue account opening",
  accessToClientProfile: "Access to client profile",
  continueClientProfile: "Continue client profile",
  generateClientAccess: "Generate client access",
  pepOnboardingSubmittedTitle: "Submission successful",
  pepOnboardingSubmittedDescription:
    "The file has been recorded and sent for processing.",
  pepOnboardingComplianceFourEyesMessage:
    "It has been sent for four-eyes review to the Compliance department.",
  pepOnboardingAccountCreationPendingMessage:
    "The client account can only be created after Compliance validation.",
  createNewProspect: "Create a new prospect",
  onboardingGate_loading: "Checking screening status…",
  onboardingGate_error:
    "Could not retrieve the screening verdict. Please try again.",
  onboardingGate_unavailable:
    "Screening verdict unavailable. Please try again.",
  onboardingGate_pass_banner:
    "Screening cleared — customer creation is allowed.",
  onboardingGate_outcome_created: "The customer was created successfully.",
  onboardingGate_sanctions:
    "Creation refused: sanctions match. The Compliance department is notified.",
  onboardingGate_pep:
    "PEP customer: the file is forwarded to Compliance for four-eyes review. Compliance takes over.",
  onboardingGate_screeningInProgress:
    "Screening in progress… The verdict will be available shortly.",
  onboardingGate_softPass:
    "The file will be forwarded to Compliance for review.",
  onboardingGate_outcome_createdRouted:
    "The customer was created. The file will be forwarded to Compliance for review.",
  onboardingGate_routedReview:
    "The file will be forwarded to Compliance for review.",
  onboardingGate_refresh: "Refresh",
  onboardingGate_routed_title: "File forwarded to Compliance",
  onboardingGate_sanctions_title: "Creation refused",

  onlyLetters: "This field must contain only letters, spaces or dashes",
  identityInformation: "Identity information",
  companyIdentityInformation: "Company identity",
  declarantContact: "Reporting contact",
  companyName: "Company name",
  registrationNumberOptional: "Registration number (RCCM)",
  contactPersonName: "Contact name",
  declarantRole: "Declarant's role",
  pmOnboardingUnavailableTitle: "Feature not available yet",
  pmOnboardingUnavailableDescription:
    "Online onboarding for legal entities is still under construction. This feature will be available soon for this prospect category.",
  understood: "Understood",

  onboarding: "Onboarding",
  productIntent: "Product intent / interest",
  backgroundToRequest: "Background to the request",
  infosIntent: "Contact Information & Intent",
  addressProfile: "Contact details (address & profile)",
  salaryAmount: "Salary (amount)",
  activitySector: "Activity sector",
  stepEntreprise: "Company",
  legalIdentificationKyb: "Legal identification (KYB)",
  addressAndContact: "Address & contact",
  tradeName: "Trade name",
  companyPhone: "Company phone",
  companyEmail: "Company email",
  legalForm: "Legal form",
  registrationNumber: "Registration number (RCCM)",
  taxId: "Tax ID (NIF)",
  incorporationCountry: "Country of incorporation",
  incorporationDate: "Incorporation date",
  shareCapital: "Share capital (FCFA)",
  headOfficeAddress: "Head office address",
  corporateObject: "Corporate object",
  legalFormSarl: "SARL",
  legalFormSa: "SA",
  legalFormSas: "SAS",
  legalFormGie: "GIE",
  legalFormHolding: "Holding",
  legalFormAssociation: "Association / NGO",
  legalFormPublicEntity: "Public entity",
  sectorCommerce: "General trade",
  sectorAgriculture: "Agriculture",
  sectorConstruction: "Construction",
  sectorRealEstate: "Real estate",
  sectorForeignExchange: "Currency exchange",
  sectorGambling: "Gambling",
  sectorFinancialServices: "Financial services",
  sectorTransport: "Transport / Logistics",
  saveSuccessful: "Saved successfully",
  saveFailed: "Save failed",
  stepRepresentants: "Representatives",
  addRepresentative: "Add a representative / proxy holder",
  removeRepresentative: "Remove",
  activeSignatoryBlocksRemoval:
    "This person already holds an active mandate. Revoke the mandate before removing them.",
  alreadyKnownInSystem: "Already known in the system",
  representativesListTitle: "Representatives and proxies",
  showDetails: "Details",
  hideDetails: "Hide",
  addedOn: "Added on",
  identitySource: "Source",
  sourceAgentInput: "Entered manually",
  sourceRicProjection: "Projected from the RIC",
  rolesHeld: "Roles",
  addRole: "Add a role",
  removeRole: "Remove",
  lastRoleCannotBeRemoved: "Last role: cannot be removed",
  noRoleToAdd: "Every available role is already assigned",
  searchExistingPerson: "Search an existing person",
  searchPersonPlaceholder: "Representative's name...",
  noResultsFound: "No results",
  manualEntry: "Manual entry",
  chooseRole: "Choose a role",
  possibleMatchesFound:
    "A matching profile already exists — reuse it or confirm this is a different person.",
  matchTypeExact: "Exact match",
  matchTypePartial: "Partial match — verify before merging",
  reuseThisPerson: "Reuse this person",
  confirmDifferentPerson: "This is a different person",
  representativeAddedSuccess: "Representative added to the case",
  removalNotSupportedYet:
    "Removing a representative isn't supported yet: assign them another role instead if needed.",
  alreadyLinkedRoles: "Roles already held",
  functionGerant: "Manager",
  functionDG: "General Manager",
  functionPDG: "Chairman & CEO",
  functionPresident: "Chairman",
  functionAdministrateur: "Director",
  residenceCountry: "Country of residence",
  identityDocumentSectionTitle: "Identity document",
  runOcr: "Run OCR",
  uploadDocumentToContinue:
    "Upload the identity document and run OCR to continue.",
  representativeDocumentType: "Document type",
  documentTypeCNI: "National ID",
  documentTypePassport: "Passport",
  documentTypeResidencePermit: "Residence permit",
  mandateSectionTitle: "Mandate & powers",
  mandateReference: "Mandate reference",
  mandateType: "Mandate type",
  mandateStartDate: "Start date",
  mandateEndDate: "End date",
  mandateCertifiedDocument: "Certified document",
  mandateTypeStatutory: "Statutory legal representative",
  mandateTypeProxy: "Proxy",
  mandateTypeDelegation: "Delegation",
  mandateTypeBankMandate: "Bank mandate",
  mandatesSectionTitle: "Mandates",
  addMandate: "Add mandate holder",
  mandateRole: "Mandate role",
  mandateRolePrincipal: "Principal",
  mandateRoleSimple: "Simple",
  mandateReason: "Reason / justification",
  mandateSaved: "Mandate holder saved successfully",
  mandateSaveFailed: "Failed to save mandate holder",
  mandateRemoved: "Mandate holder removed successfully",
  mandateRemoveFailed: "Failed to remove mandate holder",
  mandateRemoveConfirmTitle: "Remove mandate holder",
  mandateRemoveConfirmDescription:
    "Provide a reason for removal. This reason will be preserved in mandate history.",
  mandateRemoveReasonLabel: "Removal reason",
  mandateRemoveReasonPlaceholder:
    "Describe why the mandate holder is being removed… (500 chars max.)",
  mandateRemoveReasonRequired:
    "A reason is required to remove the mandate holder.",
  mandatePrincipalAlreadyExists:
    "An active principal mandate holder already exists. Only simple mandate holders can be added.",
  mandateListEmpty: "No mandate holders registered",
  stepActionnariat: "Shareholding & UBO",
  significantShareholdersQuestion:
    "Are there any shareholders holding ≥ 25% of capital or voting rights?",
  addShareholder: "Add a shareholder",
  removeShareholder: "Remove shareholder",
  personTypePP: "Individual",
  personTypePM: "Legal entity",
  percentageHeldLabel: "% held",
  shareholderLegalName: "Legal name",
  shareholderRegistryNumber: "Registry number",
  uboEffectifLabel: "Effective UBO",
  belowUboThresholdLabel: "Below 25% threshold",
  shareholdingSumError: "Direct shareholders' percentages must sum to 100%.",
  completeRequiredFieldsMessage: "Please complete all required fields.",
  controlGraphTitle: "Control graph",
  exportGraph: "Export",
  exportComingSoon: "Coming soon",
  shareholderIdentificationDate: "Identification date",
  shareholderLastVerificationDate: "Last verification",
  shareholderProofSource: "Proof source",
  legendPpIdentified: "Identified individual",
  legendPmIntermediary: "Intermediary legal entity",
  legendBelowThreshold: "Below threshold",

  stepDocuments: "Documents",
  documentChecklistTitle: "Required documents",
  documentChecklistDescription:
    "This checklist is generated from the company's legal form and country.",
  documentChecklistLoading: "Generating the document checklist…",
  documentChecklistEmpty: "No document checklist yet.",
  documentProvided: "Provided",
  documentRequiredBadge: "Required",
  documentChecklistIncompleteMessage:
    "All required documents must be marked as provided before continuing.",
  documentIndeterminateBadge: "Indeterminate",
  documentChecklistIndeterminateMessage:
    "The document requirements could not be determined yet — check with compliance before continuing.",
  documentStatusAttendue: "Awaited",
  documentStatusRecue: "Received, pending review",
  documentStatusValide: "Validated",
  documentStatusExpiree: "Expired, needs renewal",
  documentOptionalBadge: "Optional",
  documentUploadButton: "Upload the document",
  documentReplaceButton: "Replace the document",
  documentUploadUnavailable: "Online upload not available yet",
  documentUploadInProgress: "Uploading…",
  documentUploadError: "Upload failed, try again.",
  documentTypeStatuts: "Articles of association",
  documentTypeRccm: "RCCM extract",
  documentTypePieceIdentiteRl: "Legal representative's ID document",
  documentTypeNominationDirigeants: "Appointment of officers",
  documentTypeDeclarationBeneficiairesEffectifs:
    "Beneficial owners declaration",
  documentTypeConventionGie: "GIE founding agreement",
  documentTypeRecepisseDeclaration: "Declaration receipt",

  stepScreening: "Screening",
  pmScreeningTitle: "Sanctions / PEP / adverse media screening",
  pmScreeningDescription:
    "Screening is executed upstream (RIC / VNeuron) against the company, its shareholders and its representatives — this screen only projects the result.",
  pmScreeningRunning: "Projecting screening results…",
  pmScreeningEntityTypeEntreprise: "Company",
  pmScreeningEntityTypeActionnaire: "Shareholder",
  pmScreeningEntityTypeRepresentant: "Representative",
  pmScreeningListSourceSanctions: "Sanctions",
  pmScreeningListSourcePep: "PEP",
  pmScreeningListSourceAdverseMedia: "Adverse media",
  pmScreeningQualificationTruePositive: "True positive",
  pmScreeningQualificationFalsePositive: "False positive",
  pmScreeningQualificationUncertain: "Uncertain (escalated)",
  pmScreeningFalsePositivePendingValidation:
    "False positive — pending validation",
  pmScreeningStatusPending: "Pending",
  pmScreeningStatusClear: "Clear",
  pmScreeningStatusHit: "Hit",
  pmScreeningStatusInconclusive: "Inconclusive",

  stepRiskScore: "Risk score",
  riskScoreTitle: "Composite BCEAO risk score",
  riskScoreDescription:
    "Computed from the company's activity sector, its representatives and the screening results.",
  riskScoreLoading: "Computing the risk score…",
  riskScoreCompositeLabel: "Composite score",
  riskScoreLevelLabel: "Risk level",
  riskScoreFactorsTitle: "Risk factors",
  riskScoreVigilanceMessage: "Enhanced vigilance is required for this case.",
  riskLevelLow: "Low",
  riskLevelStandard: "Standard",
  riskLevelHigh: "High",
  riskLevelCritical: "Critical",
  riskFactorBase: "Base composite score",
  riskFactorHoldingStructure: "Holding / complex structure",
  riskFactorIntermediatePM: "Intermediate legal entity in the chain",
  riskFactorForeignUbo: "Foreign UBO",
  riskFactorSensitiveSector: "Sensitive activity sector",
  riskFactorPepRepresentative: "PEP (legal rep. or UBO)",
  riskFactorDigitalChannel: "Digital channel",
  riskFactorGafiNonCooperativeCountry: "FATF non-cooperative country",
  riskFactorYoungCompany: "Company under 2 years old",

  decisionOutcomeApprovedComplete: "Complete file / Approve",
  decisionOutcomeApprovedWithRestrictions: "Approve with restrictions",
  decisionOutcomeRejected: "Rejected",
  decisionOutcomeRegulatoryHold: "Regulatory hold",

  stepAccountOpening: "Account opening",
  accountOpeningTitle: "Final recap & account opening",
  accountOpeningRecapCompanyName: "Company",
  accountOpeningRecapLegalForm: "Legal form",
  accountOpeningRecapShareholders: "Shareholders",
  accountOpeningRecapScreening: "Screening",
  accountOpeningRecapScoreDecision: "Score · Decision",
  accountOpeningRecapSignatoriesTitle: "Signatories to register",
  accountOpeningBlockedMessage:
    "The account can only be created once the case has been approved.",
  accountOpeningCreateButton: "Create the account",
  accountOpeningConfirmTitle: "Create the account?",
  accountOpeningConfirmDescription:
    "This action is irreversible: the account and its signatories will be created in Orion.",
  accountOpeningConfirmAction: "Confirm creation",
  accountOpeningSuccessMessage: "Account created successfully.",
  accountOpeningAccountNumberLabel: "Account number",
  accountOpeningSignatoriesLabel: "Signatories",

  stepEvidencePack: "Evidence pack",
  evidencePackTitle: "Evidence pack",
  evidencePackDescription:
    "Exportable recap of the case, in compliance with the applicable instruction, including the next periodic review date.",
  evidencePackGenerateButton: "Generate & export the evidence pack",
  evidencePackLoading: "Generating the evidence pack…",
  evidencePackComplianceStatement:
    "This evidence pack complies with BCEAO Instruction n°003-03-2025.",
  evidencePackReferenceLabel: "Reference",
  evidencePackGeneratedAtLabel: "Generated on",
  evidencePackNextReviewDateLabel: "Next periodic review",
  evidencePackDownloadButton: "Download (PDF)",
  evidencePackRegenerateButton: "Regenerate",
  evidencePackContinueButton: "Open the account",
  evidencePackHashLabel: "Hash",
  evidencePackSectionIdentification: "Client identification",
  evidencePackSectionRegistration: "Registration & tax",
  evidencePackSectionRepresentation: "Legal representative & mandates",
  evidencePackSectionShareholding: "Shareholding & UBO",
  evidencePackSectionDocuments: "Documents received",
  evidencePackSectionScreening: "Screening results",
  evidencePackSectionRiskScore: "Risk score",
  evidencePackSectionDecision: "KYB decision",
  evidencePackSectionRestrictions: "Restrictions",
  evidencePackSectionAuditTrail: "Audit trail",
  evidencePackSectionStatusVerified: "Verified",
  evidencePackSectionStatusComplete: "Complete",
  evidencePackSectionStatusPartial: "Partial",
  evidencePackSectionStatusMissing: "Missing",
  evidencePackDetailVerified: "Verified",
  evidencePackDetailNotVerified: "Not verified",
  evidencePackDetailMissing: "Missing",
  evidencePackDetailComplete: "Complete",
  evidencePackDetailPartial: "Partial",
  evidencePackDetailHitConfirmed: "Confirmed hit",
  evidencePackDetailNone: "None",
  evidencePackDetailRestrictionsApplied: "Restrictions applied",
  evidencePackDetailAwaitingDecision: "Awaiting decision",

  request: "Request",
  partsApproval: "Parts & approvals",
  metadataOcr: "Metadata & OCR",
  summaryValidation: "Summary & validation",
  reviewSummaryTitle: "Summary — Client creation validation",
  verifyBeforeCreate: "Verify all information before confirming creation",
  screeningAndProfile: "Screening & Profile",
  screeningRule: "Rule",
  screeningDetail: "Detail",
  noScreeningRules: "No screening rules",
  screeningRulesPending: "Checks in progress, results are on their way...",
  screeningRulesUnavailable: "Screening checks are unavailable right now. Try again shortly or report it to support.",
  screeningProvider: "Source",
  screeningAdvisoryNotice: "The external VNeurone check is advisory: its verdict is recorded and passed on to compliance, but it does not block onboarding. The final decision is notified separately.",
  screeningExternalNotStarted: "The external eligibility check has not answered yet. It runs in parallel and its result will appear here: this is not a fault.",
  screeningExternalPending: "The external eligibility check opened a review at the partner bank. An analyst is clearing name matches there, and their decision will be notified to us. Onboarding is not blocked meanwhile.",
  riskFactorsTitle: "Risk factors",
  riskFactorsDecisive: "Decisive factors",
  riskFactorsOthers: "Other assessed factors",
  riskFactorsScore: "Score",
  riskFactorsCompleteness: "File completeness",
  riskFactorsHardOverride: "Override rule applied",
  riskFactorsUnavailable: "Risk factor details are unavailable for this file.",
  riskFactorNotApplicable: "Not assessed",
  riskFactorUnknownCode: "Unknown code",
  riskFactorNoValue: "No value provided",
  riskFactorsColEntity: "Entity",
  riskFactorsColValue: "Value",
  riskFactorsColLevel: "Level",
  riskFactorsColPoints: "Points",
  riskFactorsAssessedEntities: "entities assessed",

  // Screening step & OCR
  ocrExtractionTitle: "OCR extraction",
  ocrExtractionDescription:
    "Fields extracted by OCR can be reviewed and corrected before saving.",
  ocrStatusInProgress: "IN PROGRESS",
  ocrStatusFailed: "FAILED",
  ocrStatusReady: "READY",
  screeningInvalidIdTitle: "Invalid identity document",
  screeningInvalidIdDescription:
    "You cannot continue with an invalid identity document. Please upload a new valid document.",
  screeningInvalidIdInline:
    "You cannot continue while the identity document is invalid.",
  ocrApplyButton: "Validate and save",
  ocrApplyButtonLoading: "Processing...",

  // Result Screening
  SANCTIONS_PEP: "Sanctions PEP",
  ELIGIBILITE_EXTERNE: "External eligibility check",
  screeningStatus_clean_label: "CLEAN",
  screeningStatus_pending_label: "PENDING",
  screeningStatus_reject_label: "REJECTED",
  COMPLETUDE: "Completeness",
  OCR_QUALITE: "OCR quality",
  COHERENCE_IDENTITE: "Identity consistency",
  RISQUE_INITIAL: "Initial risk",

  productsAccounts: "Products & Accounts",
  productsAccountsDescription:
    "Select the type of client, product and services requested.",
  screeningContext: "Screening context",
  majorMinor: "Major/Minor",
  resident: "Resident",
  nonResident: "Non-resident",
  pepStatus: "PEP status",
  clientType: "Client type",
  product: "Product",
  productCategory: "Product category",
  additionalServices: "Additional services",
  classicCreditCard: "Classic credit card",
  classicCreditCardDescription: "Classic debit card",
  smsBanking: "SMS Banking",
  smsBankingDescription: "SMS alerts and operations",
  internetBanking: "Internet Banking",
  internetBankingDescription: "Web access to operations",
  checkbook: "Checkbook",
  checkbookDescription: "Nominative chequebook",

  // Screening status pills (labels)
  screeningStatus_ok_label: "OK",
  screeningStatus_avert_label: "WARN.",
  screeningStatus_alerte_label: "ALERT",
  screeningStatus_echec_label: "FAIL",
  screeningStatus_clear_label: "CLEAR",
  screeningStatus_faible_label: "LOW",
  screeningStatus_standard_label: "STANDARD",
  screeningStatus_high_label: "HIGH",
  screeningStatus_unknown_label: "UNKNOWN",
  screeningStatus_unknown_tooltip: "Unrecognized screening status.",

  // Screening status pills (tooltips by rule)
  screeningStatus_risqueInitial_ok: "No risk detected.",
  screeningStatus_risqueInitial_avert:
    "Moderate risk (invalid document, missing documents, etc.).",
  screeningStatus_risqueInitial_alerte: "High risk, manual review required.",

  screeningStatus_coherenceIdentite_ok: "Identity data are consistent.",
  screeningStatus_coherenceIdentite_avert:
    "Partial match (for example first names only).",
  screeningStatus_coherenceIdentite_echec:
    "Identity inconsistency or invalid identity document.",

  screeningStatus_ocrQualite_ok:
    "Quality verified, OCR data successfully extracted.",
  screeningStatus_ocrQualite_echec:
    "OCR data missing or unreadable, manual control required.",

  screeningStatus_completude_ok:
    "All required KYC documents have been provided.",

  screeningStatus_sanctionsPep_clear: "No sanctions / PEP match found.",
  screeningStatus_sanctionsPep_faible:
    "Low-relevance matches, to be monitored.",
  screeningStatus_sanctionsPep_standard:
    "Relevant matches, detailed review required.",
  screeningStatus_sanctionsPep_high:
    "High-relevance matches, high sanctions / PEP risk.",

  // Additional Documents Step (Onboarding)
  additionalDocumentsStepTitle: "Additional documents",
  requiredShort: "Required",
  optionalShort: "Optional",
  validatedShort: "Validated",
  pendingShort: "Pending",
  idDocumentName: "Identity document",
  proofOfResidenceUnder3Months: "Proof of address (≤ 3 months)",
  signedOpeningForm: "Signed account opening form",
  pepDeclaration: "PEP declaration",
  savingsObjectiveCertificate: "Savings objective certificate",

  // OCR sections
  ocrAddressContactTitle: "Address & contact",
  ocrIdentityTitle: "Client identity",
  ocrDocumentDetailsTitle: "Document details",
  ocrDocumentDetailsDescription:
    "Information extracted from the identity document. Review and correct if needed.",
  ocrFamilyTitle: "Family situation",
  ocrProfessionalTitle: "Professional situation",
  ocrAdditionalFieldsTitle: "Additional fields",
  placeholderPaysProfessionExample: "e.g. CI",

  // OCR placeholders/examples
  placeholderCityExample: "e.g. Paris",
  placeholderPostalCodeExample: "e.g. 75001",
  placeholderPlaceOfBirthExample: "e.g. Paris",
  placeholderDocumentNumberExample: "e.g. CI1234567890",
  placeholderCountryExample: "e.g. Côte d'Ivoire",
  placeholderNumberOfChildrenExample: "e.g. 2",
  placeholderProfessionExample: "e.g. Business owner",
  placeholderActivitySectorExample: "e.g. Agriculture",
  placeholderSalaryExample: "e.g. 450 000",

  // Core Banking Search
  coreBanking: "Core banking",
  searchCoreBanking: "Search for a client in core banking",
  searchCoreBankingDescription:
    "Enter an account number to query core banking. Results will appear in the list.",
  accountNumber: "Account number",
  searchCoreBankingTip:
    "Tip: you can close this dialog box, core banking results remain visible in the list.",

  // Empty State Messages
  noCustomersFound: "No customers found that match your search.",
  tryAdjustingFilters: "Try adjusting your filters to get more results.",
  startSearching: "Start by searching for or adjusting the filters above.",

  access_generated_successfully: "Access generated successfully",
  access_generated_successfully_description:
    "The access has been generated successfully. You can now log in.",
  access_generated_failed: "Failed to generate access",
  access_generated_failed_description: "An error occurred while generating.",
  access_generating: "Generating...",
  access_generating_description:
    "Access generation is in progress. Please wait.",
  regenerate_access: "Regenerate access",
  generate_access: "Generate access",
  revoke_access: "Revoke access",
  revoke_confirm_title: "Confirm access revocation",
  revoke_confirm_description:
    "This action immediately revokes the prospect's access. A reason is required.",
  revoke_sensitive_warning:
    "Sensitive action: access will be disabled immediately.",
  revoke_reason_label: "Reason",
  revoke_reason_placeholder: "Select a reason",
  revoke_reason_suspicion_fraud: "Fraud suspicion",
  revoke_reason_creation_error: "Creation error",
  revoke_reason_end_relationship: "End of prospect relationship",
  revoke_reason_customer_request: "Prospect request",
  revoke_reason_internal_control: "Internal control",
  revoke_reason_other: "Other",
  revoke_reason_custom_placeholder:
    "Specify the reason (minimum 10 characters)",
  revoke_reason_min_counter: "{{count}}/10 minimum characters",
  revoke_confirm_button: "Confirm revocation",
  revoke_confirming_button: "Revoking...",
  access_revoking: "Revoking access...",
  access_revoking_description:
    "Please wait while prospect credentials are being revoked.",
  access_revoked_successfully: "Access revoked",
  access_revoked_successfully_description:
    "Prospect access has been revoked successfully.",
  access_revoke_failed: "Failed to revoke access",
  access_revoke_failed_description: "Revocation failed. Please try again.",
  access_revoked_alert_title: "Access revoked",
  access_revoked_alert_description:
    "Access has been revoked. This prospect's access is now disabled.",

  missing: "Missing",
  uploaded: "Uploaded",
  verified: "Verified",
  required: "Required",
  optional: "Optional",
  clickToUpload: "Drop or click to add",
  notdocumentToUpload: "No document to upload",
  notdocumentToUploadDescription:
    "There are no documents to upload, you can submit the onboarding.",

  // KYC
  civilIdentity: "Civil Identity",
  actionRequired: "Action required",
  officialIdentifiers: "Official identifiers",
  notExpired: "Not expired",
  changeIdentity: "Replacement of identification document",
  contactDetails: "Contact details",
  mainMobileNumber: "Main phone number",
  secondaryMobileNumber: "Secondary phone number",
  taxationCompliance: "Taxation & Compliance",
  declarationPEP: "PEP declaration",
  CountryOfTaxation: "Country of tax residence",
  TaxIDNumber: "TIN /Tax ID number",
  pep: "PEP",
  residentStatus: "Resident status",
  residenceAddress: "Residence address",
  changeAddress: "Change address",
  reference: "Reference",
  balance: "Balance",
  money: "Currency",
  rib: "RIB",
  openAt: "Open at",
  downloadRIB: "Download RIB",
  ribDownloading: "Generating RIB...",
  ribDownloaded: "RIB downloaded",
  ribDownloadError: "Unable to download the RIB",
  miniStatement: "Mini-statement",
  viewMiniStatement: "View mini-statement",
  debit: "Debit",
  movementLabel: "Label",
  movementSense: "Sense",
  movementAmount: "Amount",
  movementBalanceAfter: "Balance after operation",
  noMovements: "No movements on this account",
  miniStatementLoadError: "Unable to load the mini-statement",
  customerDocuments: "Customer documents",
  expiration: "Expiration",
  reusable: "Reusable",
  RelatedRequest: "Related requests",
  civility: "Civility",
  sectorActivity: "Sector of activity",
  comment: "Comment",
  contactForSavingCardCredit: "Contact for saving / card / credit",

  // Dashboard Page Not Ready
  dashboardPageNotReady: "Dashboard Under Development",
  dashboardPageNotReadyDescription:
    "This page is currently under development. It will be available soon with comprehensive features for managing your dashboard.",

  // Prospects & Client360 - Common
  all: "All",
  legalPerson: "Legal Person",
  moreCharacters: "more",
  start: "Start",
  end: "End",
  datePlaceholder: "dd/mm/yyyy",
  invalidAccountNumber: "This account number is invalid.",
  accountNumberExample: "Ex: 00XXXXXXXXXX",
  pageOf: "Page {0} of {1}",
  searchAndFilterProspects: "Search and filter prospects",
  identityRepository: "Identity Repository",
  importCsv: "Import CSV",
  newProspectRequest: "New prospect request",
  importing: "Importing...",
  importAction: "Save in the reference",

  // Prospects - Status & Types
  eligible: "Eligible",
  toComplete: "To complete",
  refused: "Refused",
  duplicatePending: "Duplicate pending",
  web: "Web",
  branch: "Branch",
  corporate: "Corporate",
  clearScreening: "Clear",
  possible: "Possible",
  matchedSanction: "Matched sanction",
  noneScreening: "None",

  // Core Banking Columns
  clientCode: "Client Code",
  lastNameColumn: "Last Name",
  genderColumn: "Gender",
  nationalityColumn: "Nationality",
  maritalStatusColumn: "Marital Status",
  postalCodeColumn: "Postal Code",
  phoneColumn: "Phone",
  lastUpdateAbbr: "Last Update",

  Voir: "Open",
  minor: "Minor",
  major: "Major",
  sinceAt: "Since at",
  viewer: "View",

  digits: "digits",
  maxPhoneCharactersMessage: "The phone number cannot exceed",
  minPhoneCharactersMessage: "The phone number must contain at least",

  assignments: "Summonses",
  attributeRole: "Assign role",
  noRolesFound: "No roles found",
  rolesPerPage: "Roles per page",

  // Administration
  featureComingSoon: "This feature will be available soon in production.",
  rolesAndRights: "Roles & Rights (RBAC)",
  rolesAndRightsDescription:
    "Administration of roles, users, and security settings",
  newUser: "New user",
  newUserDialogTitle: "Add a new user manually",
  newUserDialogDescription:
    "Create a user without AD synchronization. Enter the identity information.",
  editImportDescription: "Enter the information to manually import a user.",
  phone1: "Main phone",
  email1: "Main email",
  phone2: "Secondary phone",
  email2: "Secondary email",
  chooseOrEnterEmail: "Choose or enter an email",
  chooseOrEnterPhone: "Choose or enter a phone number",
  kycInformation: "KYC Information",

  // fiche-client360 specific
  identityDocument: "Identity document",
  phoneNumbers: "Phone numbers",
  primaryPhone: "Primary phone",
  secondaryPhone: "Secondary phone",
  fax: "Fax",
  primaryEmail: "Primary email",
  secondaryEmail: "Secondary email",
  emailAddresses: "Email addresses",
  noPhoneProvided: "No phone number provided",
  noEmailProvided: "No email address provided",
  notDetermined: "Not determined",
  recentScreeningReports: "Recent screening reports",
  accountsOverview: "Accounts (overview)",
  viewAllAccounts: "View all accounts",
  complianceTitle: "Compliance",
  nextReKYC: "Next Re-KYC",
  consentsSummary: "Consents (summary)",
  openConsentCenter: "Open Consent Center",
  noResult: "No results",
  loadingError: "Error loading data",
  title: "Title",
  dataset: "Dataset",
  statusRating: "Status/Rating",
  profileNotFound: "Profile not found",
  profileNotFoundDescription:
    "The profile you are looking for does not exist or has been deleted.",
  notVerified: "Not verified",
  otpVerificationRequired:
    "Modifying the phone or email requires OTP code verification.",
  verificationCodeSent: "Verification code sent to",
  didNotReceiveCode: "Didn't receive the code?",
  resendIn: "Resend in",
  resendCode: "Resend code",
  sendCode: "Send code",
  enterMinDigitsToReceiveCode:
    "Enter at least 10 digits to receive the verification code.",
  enterValidEmailToReceiveCode:
    "Enter a valid email address to receive the verification code.",
  verify: "Verify",

  // Client360 - access regeneration tooltip
  verify_contacts_before_regenerate_access:
    "Verify the client's email or phone number to enable access regeneration.",

  // Onboarding – validation errors
  onboarding_identityDocRequired:
    "An identity document (ID card or passport) is required",
  onboarding_addressProofRequired: "Proof of address is required",
  onboarding_idInvalidUploadNew:
    "The identity document is invalid. Please upload a new valid document.",
  onboarding_applyOcrAndFillRequired:
    "Please apply the OCR form and fill in all required fields.",
  onboarding_productsAccountsRequired:
    "Products and accounts information is required",
  onboarding_uploadRequiredDocsFirst:
    "Please upload the required documents first",

  // Onboarding – toasts & submit
  onboarding_resubmit: "Re-submit",
  onboarding_submittedSuccess: "Onboarding submitted successfully",
  onboarding_submitError: "An error occurred while submitting the form",
  onboarding_businessKeyMissing: "Business key is missing",
  onboarding_submitFailed: "Onboarding submission failed",
  onboarding_productsSaveSuccess: "Products saved successfully!",
  onboarding_productsSaveSuccessDesc:
    "Products have been saved and are being processed.",
  onboarding_productsSaveFailed: "Failed to save products",
  onboarding_productsSaveFailedDesc: "Products could not be saved.",
  onboarding_productsSaving: "Saving products...",
  onboarding_productsSavingDesc: "Please wait while we save the products.",
  onboarding_productsFetchFailed:
    "Failed to retrieve products & accounts information",
  onboarding_productsFetchError:
    "An error occurred while retrieving products & accounts information",
  onboarding_identitySavedSuccess: "Identity information saved successfully",
  onboarding_identitySaveFailed: "Failed to save identity information",
  onboarding_metadataSavedSuccess: "Metadata saved successfully",
  onboarding_metadataSaveFailed: "Failed to save metadata",
  onboarding_metadataSaveError: "An error occurred while saving metadata",

  // UserProfile
  roles: "Roles",
  lastConnection: "Last connection",
  profileCreatedAt: "Created at - Updated at",
  permission: "Permissions (preview)",
  recentActivities: "Recent activities",
  action: "Action",
  inactivate: "Inactivate",
  activate: "Activate",

  // Onboarding - Document Card
  removeFile: "Remove file",
  removeFileDescription:
    "Are you absolutely sure you want to remove this file? This action cannot be undone.",
  confirm: "Confirm",
  deleting: "Deleting...",

  // Roles Matrix
  preCheckSoD: "Pre-check SoD",
  roleName: "Role name",
  roleNamePlaceholder: "Ex: Management of the branch",
  purpose: "Purpose",
  purposePlaceholder: "Ex: Management of the branch",
  scope: "Scope",
  permissionSelected: "Permissions selected",
  selected: "selected",
  loadingPermissions: "Loading permissions…",
  domain: "Domain",
  description: "Description",
  grant: "Grant",
  preCheckSoDDescription:
    "Pre-check SoD automatically after modifying permissions.",
  noConflicts: "No conflict detected",
  conflict: "Conflict detected",
  restart: "Restart",
  noDetailsShown: "No details to show",
  usersList: "Users list",
  addNewUser: "Add new user",
  addNewUserDescription:
    "Search the user by their matricule to pre-fill their informations, then create their RBAC user.",
  createUser: "Create user",
  searchUser: "Search the user",
  confirmCreation: "Confirm the creation",
  userEmail: "User email",
  searching: "Searching...",
  userFound: "User found",
  selectedUser: "Selected user",
  rbacId: "RBAC ID (username)",
  usernameLettersNumbers: "Letters, numbers, points, underscores and dashes.",
  userWillBeCreatedInactive: "User will be created with status",
  withoutRoleAssigned: "and without role assigned.",
  activeSOD: "Active SOD",
  notAvailable: "Not available",
  na: "N/A",
  sodConflicts: "SOD conflicts detected",
  sodConflictsDescription:
    "This role has conflicts with separation of duties. A justification will be required.",
  highCriticality: "High criticality",
  highCriticalityDescription:
    "This assignment requires manager approval and a written justification.",
  attribute: "Assign",
  justification: "Justification",
  justificationRequired:
    "The justification must contain at least 10 characters.",
  selectedUsers: "selected user(s)",
  noPermissions: "No permissions",
  showMore: "Show more",
  showLess: "Show less",
  owner: "Owner",
  numberOfAssignments: "Number of assignments",
  userFile: "User file",
  userFileDescription: "User file (summary of roles and permissions)",
  street: "Street",
  bankInformation: "Bank information",
  agencyCode: "Agency code",
  employmentType: "Employment type",
  company: "Company",
  otherInformation: "Other informations",
  profilRating: "Profil rating",
  customerDetailsFromCoreBanking: "Customer details from Core Banking.",
  importStep: "Update informations",

  // Commercial Dashboard (P1)
  commercialDashboard: "Commercial Dashboard",
  volumeOnboardingInities: "Volume onboarding initiés",
  kpiProspectsCrees: "Prospects Created",
  kpiKycCompletion: "KYC Completion Rate",
  kpiAvgTimeToCollect: "Avg. Collection Time",
  kpiConversionRate: "Prospect→Client Conversion Rate",
  kpiCeMois: "This month",
  kpiRetry: "Retry",
  kpiDataUnavailable: "Data temporarily unavailable",
  kpiOutlierBadge: "⚠ {{count}} file(s) > 90d",
  kpiConversionTooltip:
    "Rate calculated on prospects created and converted this month",
  kpiConversionSubLabel: "{{converted}} of {{total}} converted",
  kpiTipOnboardingVolume: "Number of onboarding files opened over the period and not yet submitted for validation.",
  kpiTipKycCompletion: "Share of clients whose KYC file was genuinely processed: identity completed and compliance check performed. A client imported from the core banking system without that journey counts in the denominator but not the numerator.",
  kpiTipTimeToCollect: "Average number of days between opening a file and submitting it. Files still in progress are counted up to today.",
  kpiTipConversion: "Share of files opened over the period that became clients. Files refused on compliance grounds are excluded.",
  kpiTipBranchSla: "Average number of days between opening the file and activating the account, for clients activated over the period.",
  kpiTipDocRejection: "Share of checked files with at least one rejected document (poor scan quality or identity mismatch). Plain completeness warnings are not counted.",
  kpiTipRekycBacklog: "Periodic review files past their due date. Pending the KYC review module.",
  kpiTipCommercialVolume: "Number of client accounts activated over the period, across all advisors.",
  kpiTipTriage: "Number of compliance alerts awaiting qualification by an analyst.",
  kpiTipEddDelay: "Average processing time of an enhanced due diligence case, from opening to decision.",
  kpiTipFalsePositive: "Share of qualified alerts that turned out to be no real match. A high rate points to overly broad filtering.",
  kpiTipBacklogAge: "Average age, in days, of alerts still awaiting qualification.",
  kpiTipSodConformity: "Share of published roles complying with segregation of duties, with no incompatible combination of functions.",
  kpiTipFourEyesSla: "Average validation time by the second approver in the four-eyes circuit.",
  kpiTipHighRiskCoverage: "Share of high-risk files already qualified by compliance. The remainder still awaits a decision.",
  kpiTipSodDerogation: "Number of segregation-of-duties waivers approved over the period.",
  kpiTipTriggerLabel: "Learn more about this indicator",
  kpiConvertedSubLabel: "{{converted}} of {{total}} converted",
  kpiDays: "d",
  kpiHours: "h",
  kpiActiveEddCasesSubLabel: "{{count}} case(s) in progress",
  kpiTrendUp: "Trending up",
  kpiTrendDown: "Trending down",

  // Dashboards — menu section & persona titles / breadcrumbs
  dashboardsSection: "Dashboards",
  dashboardCommercial: "Commercial (P1)",
  dashboardAgence: "Branch (P2)",
  dashboardCompliance: "Compliance (P3)",
  dashboardConformite: "Conformité (P4)",
  dashboardCommercialSubtitle:
    "Commercial activity and onboarding quality at a glance",
  dashboardAgenceSubtitle:
    "Branch account-opening and commercial production monitoring",
  dashboardComplianceSubtitle:
    "AML/CFT alert triage productivity and control quality",
  dashboardConformiteSubtitle: "SoD conformity, EDD coverage and derogations",
  agence: "Branch",

  // KPI — unavailable tile
  kpiComingSoon: "Coming soon",
  kpiComingSoonDescription: "This indicator is not available yet.",

  // KPI — P1 conversion drill-down card
  kpiConversionDrillDownCta: "View prospects to convert",

  // KPI — P2 (Branch)
  kpiBranchSla: "Avg. account opening time",
  kpiBranchSlaSubLabel: "{{count}} accounts opened",
  kpiDocRejection: "Document rejection rate",
  kpiDocRejectionSubLabel: "{{rejected}}/{{total}} documents rejected",
  kpiCommercialVolume: "Commercial production volume",
  kpiCommercialVolumeSubLabel: "Accounts opened in the period",
  kpiRekycBacklog: "Re-KYC backlog",

  // KPI — P3 (Compliance)
  kpiTriageProductivity: "Triage productivity",
  kpiTriageSubLabel: "{{count}} alerts in progress",
  kpiEddDelay: "Avg. EDD handling time",
  kpiFalsePositiveRate: "False-positive rate",
  kpiFalsePositiveSubLabel: "{{clear}}/{{total}} evaluated",
  kpiBacklogAge: "Avg. backlog age",

  // KPI — P4 (Conformité)
  kpiSodConformity: "SoD conformity rate",
  kpiSodConformitySubLabel: "{{compliant}}/{{total}} compliant roles",
  kpiFourEyesSla: "4-eyes validation SLA",
  kpiHighRiskCoverage: "High-risk / PEP EDD coverage",
  kpiHighRiskCoverageSubLabel: "{{covered}}/{{total}} customers covered",
  kpiHighRiskUncoveredPill: "{{count}} customers without valid EDD",
  kpiSodDerogation: "SoD derogations volume",
  kpiSodDerogationSubLabel: "{{count}} derogations granted",
  userMatricule: "User ID",
  function: "Job function",
  departement: "Department",

  assigningRoleToUsers: "Assigning role to users...",
  roleAssignedSuccessfully: "Role assigned to users successfully",
  roleAssignedSuccessfullyDescription: "Roles have been assigned successfully.",
  revokeRole: "Revoke role",
  revokeRoleConfirmTitle: "Revoke role",
  revokeRoleConfirmDescription:
    "This action removes the role from the user and is irreversible. Please justify this revocation.",
  revokingRole: "Revoking role...",
  roleRevokedSuccessfully: "Role revoked successfully",
  roleRevokedSuccessfullyDescription:
    "The role has been removed from the user successfully.",

  civilStatusAndCapacity: "Civil status & legal capacity",
  changeCivilStatus: "Change civil status",
  addLegalRepresentative: "Add legal representative",
  civilStatusLabel: "Civil status",
  legalCapacity: "Legal capacity",
  legalReferent: "Legal referent",
  fatherFirstNames: "Father's first names",
  motherFirstNames: "Mother's first names",
  deathDate: "Date of death",
  socioProfessionalSituation: "Socio-professional situation",
  updateIncomeEmployer: "Update income and employer",
  professionCountry: "Country of profession",
  clientQuality: "Client quality",
  monthlyRemuneration: "Monthly remuneration",
  bceaoSocioProNote:
    "BCEAO rule: category is distinct from profession. This data feeds the risk profile and Re-KYC periodicity.",
  matrimonialAndFamily: "Matrimonial regime & family",
  changeFamilySituation: "Change family situation",
  matrimonialRegime: "Matrimonial regime",
  marriageContract: "Marriage contract",
  spouseLastName: "Spouse's last name",
  spouseFirstName: "Spouse's first names",
  belongingAndBanking: "Belonging & banking status",
  relationOtherInstitutions: "Relationship with other institutions",
  bankPersonnel: "Bank staff",

  patrimoineRealEstateAssets: "Real estate assets",
  patrimoineRealEstateAssetsHint: "Apartments, houses, land, …",
  patrimoineHowManyProperties: "How many properties?",
  patrimoineAssetsInsured: "Are the assets insured?",
  patrimoineEstimatedValue: "Estimated value",
  patrimoineOtherBankAccounts: "Other bank accounts",
  patrimoineOtherBankAccountsHint: "Current account, savings, …",
  patrimoineTotalApproximateValue: "Total approximate value",
  patrimoineValuableObjects: "Valuable objects",
  patrimoineValuableObjectsHint: "Jewellery, art, …",
  patrimoineEdit: "Edit",

  roleBlocked: "Role blocked",
  roleBlockedDescription: "This role is blocked and cannot be published.",

  commercial: "Commercial (P1)",
  conformite: "Conformity (P4)",
  thisMonth: "This month",
  previousMonth: "Previous month",

  // Risk Entity Referential (US-6.5a)
  riskEntityReferential: "Scoring Referential",
  riskEntityReferentialDescription: "Manage risk level codes by entity type.",
  riskEntityTabEntities: "Risk entities",
  riskEntityTabWeighting: "Weighting",
  riskEntityWeightingDescription:
    "Each field accepts 0–100%. The two values must add up to exactly 100%.",
  riskEntityWeightingSectionTitle:
    "Identity Referential and External check weighting",
  riskEntityWeightingSectionSubtitle:
    "Allocate how much each external source contributes to the client risk score. A 100% split keeps the model balanced and easy to interpret.",
  riskEntityWeightingCardTitle: "Enter percentages",
  riskEntityWeightingTotalLabel: "Total",
  riskEntityWeightingLseg: "Identity Referential",
  riskEntityWeightingVneurone: "External check",
  riskEntityWeightingPercentHint: "Percentage (%)",
  riskEntityWeightingSubmitLoading: "Updating…",
  riskEntityWeightingValidate: "Update",
  riskEntityWeightingSumMustBe100:
    "Identity Referential + External check must add up to exactly 100%.",
  riskEntityWeightingInvalidPercent: "Enter a valid number.",
  riskEntityWeightingPercentRange: "Percentage must be between 0 and 100.",
  riskEntityWeightingSubmittedSuccess: "Weighting saved.",
  riskEntityWeightingConfigLoading: "Loading current weighting…",
  riskEntityWeightingReason: "Reason for change",
  riskEntityWeightingReasonPlaceholder:
    "E.g. switch to CONSERVATIVE mode — SteerCo decision 2026-07-15",
  riskEntityWeightingReasonRequired: "Reason is required.",
  riskEntityWeightingReasonMinLength:
    "The reason must be at least 5 characters long.",
  riskEntityWeightingHistorySheetTitle:
    "History — Identity Referential / External check weighting",
  riskEntityWeightingHistorySheetSubtitle:
    "Each row is a saved change (weights, author, reason).",
  riskEntityWeightingHistoryLoading: "Fetching history…",
  riskEntityWeightingHistoryEmpty: "No history entries yet.",
  riskEntityWeightingHistoryColDate: "Date",
  riskEntityWeightingHistoryColAuthor: "User",
  riskEntityWeightingHistoryColBefore: "Before (Identity Ref. / External)",
  riskEntityWeightingHistoryColAfter: "After (Identity Ref. / External)",
  riskEntityWeightingHistoryColReason: "Reason",
  entityType_OBJET_COMPTE: "Account Object",
  entityType_SOURCE_REVENU: "Income Source",
  entityType_PAYS: "Country",
  entityType_PROFESSION: "Profession",
  entityType_ACTIVITE: "Activity",
  entityType_PRODUIT: "Product",
  entityType_CANAL: "Channel",
  entityType_ANNEE_CONSTITUTION: "Incorporation Year",
  riskLevel_RE: "RE — High Risk",
  riskLevel_RM: "RM — Moderate Risk",
  riskLevel_RF: "RF — Low Risk",
  riskEntityCode: "Code",
  riskEntityLibelle: "Label",
  riskEntityLevel: "Level",
  riskEntityActive: "Active",
  riskEntityLastModified: "Last modified",
  riskEntityAddCode: "Add a code",
  riskEntityEditLevel: "Edit level",
  riskEntityDeactivate: "Deactivate",
  riskEntityHistory: "History",
  riskEntityNewCode: "New code",
  riskEntityEditCode: "Edit code",
  riskEntityDeactivateTitle: "Deactivate this code?",
  riskEntityDeactivateDescription:
    "The code will be hidden from scoring but remain visible in the table.",
  riskEntityRollbackTitle: "Restore this version?",
  riskEntityRollbackDescription:
    "This action will apply the previous state and create an audit entry.",
  riskEntityRollbackConfirm: "Restore",
  riskEntityRestoreVersion: "Restore this version",
  riskEntityChangeReason: "Reason for change",
  riskEntityChangeReasonPlaceholder: "Enter the reason for this change…",
  riskEntityNoCodesFound: "No codes found",
  riskEntityFilterByLevel: "Filter by level",
  riskEntityAllLevels: "All levels",
  riskEntitySearchPlaceholder: "Search by code or label…",
  riskEntityStatusActive: "Active",
  riskEntityStatusInactive: "Inactive",
  riskEntityHistoryAction_ADD: "Addition",
  riskEntityHistoryAction_MODIFY: "Modification",
  riskEntityHistoryAction_DEACTIVATE: "Deactivation",
  riskEntityHistoryAction_ROLLBACK: "Rollback",
  riskEntityCreatedSuccess: "Code created successfully",
  riskEntityUpdatedSuccess: "Level updated successfully",
  riskEntityDeactivatedSuccess: "Code deactivated successfully",
  riskEntityRolledBackSuccess: "Version restored successfully",
  riskEntityOperationFailed: "Operation failed. Please try again.",
  riskEntityCodes: "code(s)",
  riskEntityModifyConfirmTitle: "Confirm modification",
  riskEntityNoHistory: "No history available for this entity type.",

  // Risk Entity Referential — CSV Import (US-6.5b)
  riskEntityImportCsv: "Import CSV",
  riskEntityImportModalTitle: "Import codes via CSV",
  riskEntityImportDropzone: "Drag & drop a .csv file here or click to select",
  riskEntityImportDropzoneHint:
    "Expected format: code,label,risk_level (UTF-8)",
  riskEntityImportSelectFile: "Select a file",
  riskEntityImportPreviewTitle: "Preview changes",
  riskEntityImportAdded: "Added",
  riskEntityImportModified: "Modified",
  riskEntityImportUnchanged: "Unchanged",
  riskEntityImportInvalid: "Invalid",
  riskEntityImportConfirmBtn: "Confirm import",
  riskEntityImportSuccess:
    "Import applied: {applied} modified, {added} added, {errors} errors",
  riskEntityImportShowUnchanged: "Show unchanged",
  riskEntityImportHideUnchanged: "Hide unchanged",
  riskEntityImportErrorReason: "Reason",
  riskEntityImportEmpty: "The file is empty or contains no valid rows.",
  riskEntityImportFileTypeError:
    "Unsupported format. Please select a .csv file.",
  riskEntityImportColumnCode: "Code",
  riskEntityImportColumnLabel: "Label",
  riskEntityImportColumnOldLevel: "Current level",
  riskEntityImportColumnNewLevel: "New level",
  riskEntityImportColumnStatus: "Status",
  riskEntityImportChooseAnother: "Choose another file",
  riskEntityImportConfirmCloseTitle: "Cancel import?",
  riskEntityImportConfirmCloseDescription:
    "The parsed file will be discarded. You will need to select it again.",

  // Risques Conformité — menu
  risquesConformite: "Compliance & Risk",
  fileDeRevueL1: "Review queue",
  validation4Yeux: "Reclassifications",

  // EDD 4-yeux module
  eddTitle: "Due diligence (EDD)",
  eddEmpty: "No EDD cases.",
  eddColBusinessKey: "Business ID",
  eddColCustomer: "Customer",
  eddColTrigger: "Trigger",
  eddColStatus: "Status",
  eddColAnalyst: "Analyst",
  eddColCreatedAt: "Created",
  eddFilterAll: "All",
  eddFilterAssignedToMe: "Assigned to me",
  eddStatus_OPEN: "Open",
  eddStatus_IN_PROGRESS: "In progress",
  eddStatus_PENDING_L1: "Pending L1",
  eddStatus_PENDING_L2: "Pending L2",
  eddStatus_APPROVED: "Approved",
  eddStatus_REJECTED: "Rejected",
  eddStatus_SUSPENDED: "Suspended",
  eddTrigger_PEP: "PEP",
  eddTrigger_PEP_SANCTIONED: "PEP + sanctioned country",
  eddTrigger_HIGH_RISK: "High risk",
  eddTrigger_MANUAL: "Manual",
  eddTrigger_ESCALATION_L1: "L1 review escalation",
  eddTrigger_RE_KYC: "Re-KYC",
  eddTrigger_TRANSACTION_ALERT: "Transaction alert",
  eddTrigger_UNKNOWN: "Other",
  eddDocType_IDENTITY: "Identity document",
  eddDocType_SOURCE_OF_FUNDS: "Source of funds",
  eddDocType_BUSINESS_ACTIVITY: "Business activity",
  eddDocType_BENEFICIAL_OWNER: "Beneficial owner",
  eddDocType_OTHER: "Other",
  eddDocumentsTitle: "Supporting documents",
  eddNoDocuments: "No documents.",
  eddDownload: "Download",
  eddPreview: "Preview",
  eddUploadTitle: "Add a document",
  eddUploadType: "Document type",
  eddUploadFile: "File",
  eddUploadComment: "Comment (optional)",
  eddUploadSubmit: "Upload",
  eddHistoryTitle: "History",
  eddActionAddDocument: "Add a document",
  eddActionSubmitL1: "Submit for L1 review",
  eddActionSubmitL1Hint: "At least one 'Source of funds' document is required.",
  eddActionAssign: "Take ownership",
  eddActionSuspend: "Suspend",
  eddActionResume: "Resume",
  eddActionApproveL1: "Approve (L1 branch)",
  eddActionApproveL2: "Approve (L2 compliance)",
  eddActionApproveL2FourEyesHint:
    "Four-eyes control: the L2 approver must differ from the L1 approver.",
  eddActionReject: "Reject",
  eddRejectReason: "Rejection reason",
  eddSuspendReason: "Suspension reason",
  eddMfaTitle: "Security verification (MFA)",
  eddMfaSentTo: "A verification code was sent to",
  eddMfaExpiresIn: "expires in",
  eddMfaSendError: "Could not send the verification code. Please retry.",
  eddMfaCodeLabel: "Verification code (6 digits)",
  eddMfaResend: "Resend a code",
  eddMfaValidate: "Verify and confirm",
  eddDecisionNotes: "Notes (optional)",
  eddApproveL2Title: "Approve (L2 compliance)",
  eddApproveL2RiskAssessment: "Risk re-assessment",
  eddApproveL2Conclusion: "Conclusion (optional)",
  eddRisk_MAINTAINED: "Maintained",
  eddRisk_UPGRADED: "Upgraded",
  eddRisk_DOWNGRADED: "Downgraded",

  // L1 Review page (US 6.3)
  l1ReviewTitle: "L1 review queue",
  l1ReviewBusinessKey: "Business Key",
  l1ReviewCustomerName: "Name",
  l1ReviewAssignedTo: "Assigned to",
  l1ReviewUnassigned: "Unassigned",
  l1ReviewRisk: "Risk",
  l1ReviewTabPending: "Pending",
  l1ReviewTabEscalated: "Escalated",
  l1ReviewTabAuthorized: "Authorized",
  l1ReviewTabRejected: "Rejected",
  l1ReviewTabSlaBreached: "SLA breached",
  l1ReviewDetailTitle: "L1 review case detail",
  l1ReviewDetailNotFound: "Case not found.",
  l1ReviewTriggerReason: "Trigger",
  l1ReviewTrackAScore: "Identity Reference score",
  l1ReviewTrackBScore: "External check score",
  l1ReviewSlaDeadline: "SLA Deadline",
  l1ReviewSlaExpired: "SLA Expired",
  l1ReviewAuthorize: "Authorize",
  l1ReviewSuspend: "Suspend",
  l1ReviewReject: "Reject",
  l1ReviewAssign: "Assign to me",
  l1ReviewHeldBy: "Already assigned; only its assignee can act on it",
  l1ReviewAssignHint: "Assign the case to yourself before authorizing it.",
  l1ReviewQualifyFirstHint:
    "Resolve every match first: the decision can only be made once you know whether this is the person.",
  l1ReviewEscalate: "Escalate",
  l1ReviewSuspensionReason: "Suspension reason",
  l1ReviewSuspensionReasonPlaceholder: "Describe the reason for suspension…",
  l1ReviewAuthorizeSuccess: "Case authorized successfully.",
  l1ReviewSuspendSuccess: "Case suspended successfully.",
  l1ReviewEscalateSuccess: "Case escalated to P4 validation.",
  l1ReviewActionFailed: "Action failed. Please try again.",
  l1ReviewEmpty: "No pending cases to review.",
  l1ReviewLoading: "Loading pending cases…",
  l1ReviewLoadingError: "Failed to load cases. Please retry.",

  // P4 Validation page (US 4.5)
  p4ValidationTitle: "Risk reclassifications (P4)",
  p4ValidationBusinessKey: "Customer ID",
  p4ValidationOldClass: "Current class",
  p4ValidationNewClass: "New class",
  p4ValidationScoreDelta: "Score Δ",
  p4ValidationTrigger: "Trigger",
  p4ValidationSlaDeadline: "SLA Deadline",
  p4ValidationSlaExpired: "SLA Expired",
  p4ValidationFlaggedDirectionRisques: "Flagged — Direction Risques",
  p4ValidationApprove: "Approve",
  p4ValidationReject: "Reject",
  p4ValidationJustification: "Justification",
  p4ValidationJustificationPlaceholder:
    "Provide a justification for rejection (min. 10 characters)…",
  p4ValidationNotes: "Notes (optional)",
  p4ValidationNotesPlaceholder: "Additional notes…",
  p4ValidationApproveSuccess: "Validation approved. New risk class applied.",
  p4ValidationRejectSuccess:
    "Validation rejected. Current risk class preserved.",
  p4ValidationActionFailed:
    "The action could not be completed. Please try again shortly.",
  p4ValidationForbidden:
    "You are not allowed to validate a risk reclassification. This decision is reserved for a Compliance Manager (P4).",
  p4ValidationSelfReviewForbidden:
    "Decision not allowed: under the four-eyes principle, the person who triggered the change cannot validate it. Another reviewer must handle it.",
  p4ValidationAlreadyDecided:
    "This reclassification has already been handled by another reviewer. The list will refresh.",
  p4ValidationEmpty: "No reclassification to validate right now.",
  p4ValidationEmptyApproved: "No approved reclassification to display.",
  p4ValidationEmptyRejected: "No rejected reclassification to display.",
  p4ValidationLoading: "Loading reclassifications…",
  p4ValidationLoadingError: "Failed to load reclassifications. Please retry.",
  p4ValidationPendingCount: "awaiting validation",
  // Status filter + business descriptions above the list
  p4StatusPending: "To validate",
  p4StatusApproved: "Approved",
  p4StatusRejected: "Rejected",
  p4StatusDescPending:
    "These customers' risk level has changed (e.g. Low → High). A second reviewer must confirm or refuse the change before it becomes final. The customer stays active meanwhile.",
  p4StatusDescApproved:
    "Confirmed risk-level changes: the new level has been applied to the customer. Read-only history.",
  p4StatusDescRejected:
    "Refused risk-level changes: the customer keeps their previous level. Flagged cases are escalated to the risk department for follow-up.",

  // Compliance triage — shared header, SLA countdown, queue summary, toolbar
  l1ReviewSubtitle: "Level-1 review of screening alerts, sorted by deadline.",
  p4ValidationSubtitle:
    "Second-line check of risk-level changes (Low ↔ High) on existing customers, sorted by deadline.",
  eddSubtitle: "Enhanced due-diligence cases in progress (four-eyes).",
  slaDueIn: "Due in",
  slaOverdueSince: "Overdue by",
  queueTotalPending: "Pending",
  queueDueSoon: "Due < 2 h",
  queueBreached: "SLA breached",
  queueFlaggedDR: "Flagged DR",
  eddQueueOpen: "Open",
  eddQueuePendingL1: "Pending L1",
  eddQueuePendingL2: "Pending L2",
  eddRowClickHint: "Select a case to view its details.",
  eddOpenCaseAria: "Open case",
  eddDetailBack: "Back to cases",
  eddDetailCaseInfoTitle: "Case information",
  eddDetailSubmittedAt: "Submitted on",
  eddDetailL1ApprovedBy: "L1 approved by",
  eddDetailL2ApprovedBy: "L2 approved by",
  eddDetailSlaDeadline: "SLA deadline",
  eddDetailNotFound: "Case not found.",
  eddCustomerDetailsTitle: "Prospect details",
  eddCustomerLoadError: "Unable to load the prospect details.",
  eddCustomerDocumentsTitle: "Customer documents",
  eddCustomerNoDocuments: "No document.",
  eddCustomerDocColType: "Type",
  eddCustomerDocColName: "Document",
  eddCustomerDocColExpiration: "Expiration",
  eddCustomerDocView: "View",
  complianceSearchBusinessKey: "Business key",
  complianceFilterTrigger: "Reason",
  complianceFlaggedOnly: "Flagged DR only",
  p4ValidationRiskChange: "Risk-class change",
  l1AuthorizeConfirmTitle: "Authorize this review?",
  l1AuthorizeConfirmBody:
    "The review will be authorized and removed from the queue. This action is final.",
  l1EscalateConfirmTitle: "Escalate this review?",
  l1EscalateConfirmBody:
    "The review will be escalated to P4 validation. This action is final.",

  // Tracks are named after what they mean to the bank, never after the vendor behind them.
  cvTrackA: "Identity Referential",
  cvTrackB: "External check",
  cvFinalDecision: "Final decision",
  cvWeights: "Weights",
  cvDecidedBy: "Decided by",
  cvScoringWeights: "Scoring weights",
  cvCanCreate: "Creation allowed",
  cvCannotCreate: "Creation blocked",
  cvVerdictHold: "Under review",
  cvVerdictUnknown: "Unknown status",
  cvHoldPending:
    "Prospect recorded, no account opened until the review is cleared",
  cvBlockingReason: "Blocking reason",
  cvVNeuroneMode: "External check mode",
  cvComputedAt: "Computed at",
  cvVerdictClean: "Clean",
  cvVerdictWait: "Wait",
  cvVerdictFlagged: "Flagged",
  cvVerdictBlocked: "Blocked",
  cvVerdictManualReview: "Manual review",
  cvPendingOver48h: "Pending over 48h",
  cvScreeningDetails: "Screening details",
  cvLoadError: "Unable to load verdict.",

  additionalInformationKYC: "Additional KYC information",
  additionalInformationKYCDescription:
    "Update the client's additional information.",
  financialSituationSection: "Financial situation",
  pepStatusSection: "PEP status",
  effectiveBeneficiarySection: "Effective beneficiary",
  wealthSituation: "Wealth situation",
  sourceOfFunds: "Source of funds",
  bankRelationPurpose: "Purpose of the banking relationship",
  taxResidenceCountry: "Tax residence (country)",
  pepFunctionExercised: "PEP function exercised",
  effectiveBeneficiary: "Effective beneficiary",
  effectiveBeneficiaryIdentity: "Identity of the effective beneficiary",
  placeholderWealthSituation: "E.g. real estate, savings, investments",
  placeholderSourceOfFunds: "E.g. salary, inheritance, asset sale",
  placeholderBankRelationPurpose:
    "E.g. savings, day-to-day operations, international transfers",
  placeholderTaxResidenceCountry: "E.g. Côte d'Ivoire",
  placeholderPepFunction: "E.g. minister, MP, judge…",
  placeholderEffectiveBeneficiaryIdentity:
    "E.g. full name and capacity of the beneficiary",
  immatriculationsSectionTitle: "Registrations",
  taxIdentifiersSectionTitle: "Tax identifiers",
  addImmatriculation: "Add a registration",
  addTaxIdentifier: "Add a tax identifier",
  removeImmatriculation: "Remove",
  removeTaxIdentifier: "Remove",
  registryType: "Registry type",
  registryTypeRCCM: "RCCM",
  registryTypeOther: "Other",
  immatriculationNumber: "Registration number",
  immatriculationDate: "Registration date",
  immatriculationStatus: "Verification status",
  statusVerified: "Verified",
  statusNotVerified: "Not verified",
  statusInProgress: "In progress",
  statusToReverify: "To re-verify",
  registrationSyncedReadOnly:
    "Added to the case. Verification status is decided by compliance, backed by proof.",
  justificationAlternative: "Alternative justification",
  pendingComplianceValidation: "Pending compliance validation",
  taxIdentifierType: "Tax identifier type",
  taxIdentifierTypeIFU: "IFU",
  taxIdentifierTypeNIF: "NIF",
  taxIdentifierTypeNINEA: "NINEA",
  taxIdentifierTypeOther: "Other",
  taxIdentifierValue: "Value",
  immatriculationGateBlocked:
    "This dossier cannot be approved yet: no registration has been verified. An alternative justification still needs to be validated by compliance.",
  registrationVerificationDecide: "Decide",
  registrationVerificationTitle: "Verification decision",
  registrationVerificationTargetStatus: "Target status",
  registrationVerificationSource: "Verification source",
  registrationVerificationJustification: "Justification",
  registrationVerificationProofFile: "Proof to upload",
  registrationVerificationSubmit: "Save decision",
  registrationVerificationCancel: "Cancel",
  registrationVerificationProofRequired:
    "A proof file is required for the Verified status.",
  registrationVerificationPendingSync:
    "Save the case first before deciding on its verification.",
  registrationVerificationError:
    "The decision could not be saved. Check the information and try again.",

  ocrChangeCriticalTitle: "Identity information is about to change",
  ocrChangeCriticalIntro:
    "You are about to change information that identifies the customer:",
  ocrChangeCriticalConsequence:
    "This restarts the customer's compliance checks and is recorded under your name. Make sure it matches the document presented.",
  ocrChangeCriticalAttestation:
    "I confirm I checked this information against the original identity document",
  ocrChangeReasonLabel: "Reason for the change",
  ocrChangeReasonPlaceholder:
    "e.g. OCR misreading corrected against the document presented",
  ocrChangeSensitiveTitle: "Information changed by the new reading",
  ocrChangeSensitiveIntro:
    "Reading the document again changes the following information:",
  ocrChangeNewCaptureTitle: "Information detected on the document",
  ocrChangeNewCaptureIntro:
    "Reading the document detected the following information, not yet recorded on this file. Check it is correct before continuing:",
  ocrChangeDetectedValue: "Detected value",
  ocrChangeAlsoChanged: "Also changed:",
  ocrChangeLegalAgeWarning:
    "This date moves the customer from minor to adult (or the other way round): the list of required documents will change.",
  ocrChangeIdPaperWarning:
    "If this document number is already registered on another customer, the change will be rejected.",
  ocrChangeBefore: "Before",
  ocrChangeAfter: "After",
  ocrChangeCancel: "Cancel",
  ocrChangeConfirm: "Confirm the change",
  ocrChangeFieldLastName: "Last name",
  ocrChangeFieldFirstName: "First name",
  ocrChangeFieldBirthDate: "Date of birth",
  ocrChangeFieldIdPaperNumber: "Document number",
  ocrChangeFieldNni: "National ID number",
  ocrChangeFieldNationality: "Nationality",
  ocrChangeFieldBirthPlace: "Place of birth",
  ocrChangeFieldGender: "Gender",
  ocrChangeFieldDeliveryDate: "Issue date",
  ocrChangeFieldValidityDate: "Expiry date",
  staffDirectoryTitle: "Staff directory",
  staffDirectoryBranch: "Assigned branch",
  staffDirectoryEmail: "Email sent to screening",
  staffDirectoryNoBranch:
    "No assigned branch in the staff directory. The files you open carry neither adviser nor branch and are not screened: have your assignment created before registering a new customer.",
  staffDirectoryAmbiguousBranch:
    "Several assigned branches in the staff directory, so none can be used. The files you open are not screened until a single one remains.",
  staffDirectoryBranchCount: "Assigned branches",
    accountOpeningRecapDecision: "Decision",
    accountOpeningRecapRepresentatives: "Representatives",
    accountOpeningRecapRiskLevel: "Risk level",
    decisionJustificationLabel: "Justification",
    decisionMakerNameLabel: "Deciding agent",
    decisionOutcomeLabel: "Outcome",
    decisionOutcomeRequestAdditionalInfo: "Request additional information",
    decisionTitle: "KYB decision",
    pmScreeningLaunchButton: "Launch screening",
    pmScreeningNoHitsMessage: "No hits found. Screening is clear.",
    pmScreeningQualificationPending: "Pending",
    pmScreeningQualifyFalsePositive: "False positive",
    pmScreeningQualifyTruePositive: "True positive",
    pmScreeningUnqualifiedHitsBlockMessage:
    "Every hit must be qualified before continuing.",
    riskFactorScreeningHit: "Confirmed screening hit",
    riskLevelEleve: "High",
    riskLevelFaible: "Low",
    riskLevelModere: "Medium",
  
  stepDecision: "Decision",

  platformSettings: "Platform settings",
  platformSettingsDescription:
    "Module activation and toggles reserved to the editor.",
  kybModuleToggleTitle: "KYB module (legal entity onboarding)",
  kybModuleToggleDescription:
    "Enables or disables legal entity onboarding (KYB) across the whole application: PM segment, KYB cases, associated screens.",
  kybModuleToggleEnabled: "Enabled",
  kybModuleToggleDisabled: "Disabled",
  kybModuleUnavailableTitle: "Module not active",
  kybModuleUnavailableMessage:
    "This module is not active. Please request its activation in your subscription.",
  identityPolicyToggleTitle: "Reason required on identity changes",
  identityPolicyToggleDescription:
    "On: any change to an identifying field (name, first name, date of birth, ID number, national ID, nationality) requires a reason, rejected with 400 otherwise. Off: the reason stays optional.",
  screeningPolicyPepTitle: "Block creation on PEP hit",
  screeningPolicyPepDescription:
    "On: a Track A PEP hit blocks customer creation until 4-eyes EDD is APPROVED.",
  screeningPolicyHighTitle: "Block creation on HIGH scoring",
  screeningPolicyHighDescription:
    "On: a Track A HIGH score blocks creation and opens an L1 review (soft gate).",
  screeningPolicyVneuroneModeLabel: "VNeurone mode",
  screeningPolicyProviderLabel: "Active AML provider",
  secretEncryptionTitle: "Secret encryption",
  secretEncryptionDescription:
    "Turns a plaintext value into the ENC(...) format expected by .properties files and Kubernetes secrets, for a key rotation.",
  secretEncryptionInputLabel: "Plaintext value",
  secretEncryptionInputPlaceholder: "Paste the value to encrypt",
  secretEncryptionButton: "Encrypt",
  secretEncryptionOutputLabel: "Encrypted value",
  secretEncryptionCopy: "Copy",
  secretEncryptionCopied: "Copied to clipboard",
  secretEncryptionError: "Encryption failed. Please try again.",
  customerPurgeTitle: "Customer purge",
  customerPurgeDescription:
    "Fully deletes a customer (database, Keycloak identity, MinIO objects) to replay a test with the same ID document and phone number. Irreversible.",
  customerPurgeBusinessKeyLabel: "Customer businessKey",
  customerPurgeBusinessKeyPlaceholder: "e.g. aaa0087",
  customerPurgeButton: "Purge",
  customerPurgeConfirmTitle: "Confirm the purge",
  customerPurgeConfirmDescription:
    "This action is irreversible: all of the customer's data will be deleted.",
  customerPurgePasswordLabel: "Your password",
  customerPurgePasswordPlaceholder: "Password",
  customerPurgeConfirmButton: "Confirm the purge",
  customerPurgeSuccess: "Customer purged.",
  customerPurgeError: "Purge failed. Check the businessKey and your password.",
  customerPurgeUnlockButton: "Unlock",
  customerPurgeLockedHint: "Enter your password to unlock this zone.",
  customerPurgeBusinessKeyInvalid: "Expected format: 3 letters + 4 digits, e.g. aaa0087.",

  agences: "Branches",
  agencesDescription: "Branch directory - read-only.",
  agenceCode: "Code",
  agenceName: "Name",
  agenceCity: "City",
  agenceAddress: "Address",
  agenceContact: "Contact",
  agenceCoordinates: "Coordinates",
  agenceHours: "Opening hours",
  agenceHoursOrdinary: "Weekdays",
  agenceHoursSaturday: "Saturday",
  agenceHoursSunday: "Sunday",
  agenceEmptyState: "No branches found.",
  agenceLoadError: "Could not load the branch directory.",
  subscriptionChannel: "Subscription channel",
};

export default en;
